import windowService from '../../../services/windowService';
import {
  ChurchAccountRedirect,
  clearChurchAccountRedirect,
  setChurchAccountRedirect,
} from '../state/churchAccountRedirect';

export const redirectToCreateChurchAccount = (redirect?: ChurchAccountRedirect) => {
  if (redirect) {
    setChurchAccountRedirect(redirect);
  } else {
    clearChurchAccountRedirect();
  }

  windowService.redirectToMyLifeway(`${window.config.MYLIFEWAY_CREATE_ACCOUNT_PATH}?referrer=ministry-grid`);
};
